export default __webpack_public_path__ + "images/WA.a50b220.png";